import PublicAppVars from "./PublicAppVars.js";

const NoOffsiteUrl = (unsafeUrl) => {
	// only keep the path portion to make sure we're not sending the user offsite unintentionally

	const parsedUrl = new URL(unsafeUrl, PublicAppVars.PUBLIC_URL);
	return parsedUrl.pathname + (parsedUrl.search || '');
};
export default NoOffsiteUrl;
